import React from "react";
import { useEffect } from "react";
import { AuthRestartButton } from "../misc/restart-button.component";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import getPaymentDay from "../misc/get-payment-day";
import { ClosedEndRecurringDisclosure } from "../misc/disclosures";
import { generateLoanDescription } from "../misc/messaging-utils";

export const AuthRecurringClosedEndReview = (props) => {
  const advance = () => {
    window.scrollTo(0, 0);
    props.callAuthSubmitPayment();
  };

  useEffect(() => {
    // If the payment response has this property, that means there were no errors
    // submitting the payment and the paymentResponse property has been set
    if (props.paymentResponse.hasOwnProperty("AmountDue")) {
      props.continue();
    }
  }, [props.paymentResponse]);

  return (
    <AuthPaymentContainer title="Review & Submit">
      <div className="text-centered bold f20">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <ReviewDisplayField title={"First Payment Date"} value={props.firstPaymentDate} />
        <ReviewDisplayField
          title={"Payment Frequency"}
          value={props.paymentFrequency}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField
          title={"Payment Day"}
          value={getPaymentDay(props.paymentFrequency, props.firstPaymentDate)}
          valueClassNames={"minwidth-fit"}
          titleColumnSize={"col-md-5"}
          valueColumnSize={"col-md-7"}
        />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`Ending in ${props.paymentAccount}`}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
      </div>
      {ClosedEndRecurringDisclosure(props.isInternalTransfer)}
      <AuthContinue
        type="button"
        title="Submit Payment"
        onClickFunction={() => advance()}
      />
      <AuthRestartButton backToLoans={props.backToLoans} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/review/auth-recurring-closed-end-review-fields.component.js